
type QueryStringState = {
    currentDate?: string,
    searchBy?: string,
    sortBy?: string,
    term?: string,
    operaFilter?: string,
}

export const getStateFromQueryString = () => {
    const url = window.location.search;
    const urlParams = new URLSearchParams(url);

    return {
        ...(urlParams.has('searchBy') && { searchBy: urlParams.get('searchBy') }),
        ...(urlParams.has('sortBy') && { sortBy: urlParams.get('sortBy') }),
        ...(urlParams.has('term') && { term: urlParams.get('term') }),
        ...(urlParams.has('operaFilter') && { operaFilter: urlParams.get('operaFilter') }),
    } as QueryStringState;
}

export const writeStateToUrl = (
    searchBy?: string,
    term?: string,
    sortBy?: string) => {
   
    const baseUrl = window.location.origin + window.location.pathname;
    return history.pushState({}, "", `${baseUrl}?searchBy=${searchBy}&term=${term}&sortBy=${sortBy}`);
}